import { renderIcon as u, renderSuggestion as o } from "./-search-form.js";
const r = class r extends HTMLElement {
  constructor() {
    var e, t;
    super(), this.renderIcon = u, this.renderSuggestion = o, this.form = this.querySelector("form"), this.input = (e = this.form) == null ? void 0 : e.querySelector(
      'input[type="search"]'
    ), this.clear = (t = this.form) == null ? void 0 : t.querySelector(
      'button[type="reset"]'
    ), this.results = null, this.suggestions = this.querySelector("#SearchSuggestions"), this.productSuggestions = this.querySelector(
      "#ProductSuggestions"
    ), this.viewAll = this.querySelector("[data-view-all]");
  }
  connectedCallback() {
    !this.form || !this.input || (this.form.addEventListener("input", (e) => {
      e.preventDefault(), this.handleSubmit();
    }), this.form.addEventListener("reset", () => {
      this.handleClear();
    }), this.viewAll && this.viewAll.addEventListener("click", (e) => {
      var t;
      e.preventDefault(), (t = this.form) == null || t.submit();
    }), this.clear && this.clear.addEventListener("click", (e) => {
      e.preventDefault(), this.handleReset();
    }));
  }
  attributeChangedCallback(e) {
    (e === "data-product-count" || e === "data-content-count") && this.updateState();
  }
  handleSubmit(e = !1) {
    if (!(!this.form || !this.input)) {
      if (!this.input.value || this.input.value.length < 3) {
        this.handleClear();
        return;
      }
      this.search(this.input.value), !e && this.searchProducts(this.input.value);
    }
  }
  handleClear() {
    !this.suggestions || !this.productSuggestions || (this.suggestions.innerHTML = "", this.productSuggestions.innerHTML = "", this.dataset.contentCount = "0", this.dataset.productCount = "0");
  }
  handleReset() {
    this.handleClear(), this.input && this.input.value !== "" && (this.input.value = ""), setTimeout(() => {
      var e;
      (e = this.input) == null || e.focus();
    }, 100), this.updateState();
  }
  search(e) {
    fetch(`https://search.watchesofswitzerland.com/?q=${e}`, {
      method: "GET"
    }).then((t) => t.json()).then((t) => {
      var s;
      t && (this.results = (s = t == null ? void 0 : t.result) == null ? void 0 : s.results, this.renderSuggestions());
    }).catch((t) => {
      console.error("Error fetching search results:", t);
    });
  }
  renderSuggestions() {
    if (!this.suggestions || !this.results)
      return;
    if (this.dataset.contentCount = this.results.hits.length.toString(), this.results.hits.length === 0) {
      this.suggestions.innerHTML = "";
      return;
    }
    const e = this.results.hits.slice(0, 6);
    let t = "";
    e.forEach((s) => {
      t += this.renderSuggestion(s.document);
    }), this.suggestions.innerHTML = t;
  }
  searchProducts(e) {
    fetch(`/search?q=${e}&section_id=search-suggestions`).then((t) => t.text()).then((t) => {
      if (t) {
        const i = new DOMParser().parseFromString(t, "text/html").querySelector(
          "#ProductSuggestions"
        ), h = this.querySelector(
          "#ProductSuggestions"
        );
        h && i && (h.innerHTML = i.innerHTML || "", this.dataset.productCount = i.dataset.productCount || "0");
      }
    }).catch((t) => {
      console.error("Error fetching search results:", t);
    });
  }
  updateState() {
    if (this.dataset.productCount === "" || this.dataset.contentCount === "") {
      this.dataset.results = "ready";
      return;
    }
    this.dataset.productCount === "0" && this.dataset.contentCount === "0" ? this.dataset.results = this.input && this.input.value.length > 2 ? "none" : "ready" : this.dataset.results = "some";
  }
};
r.observedAttributes = ["data-product-count", "data-content-count"];
let n = r;
window.customElements.define("search-suggestions", n);
export {
  n as SearchSuggestions
};
